import DefaultLayout from 'admin/components/DefaultLayout';
import { useIntl } from 'react-intl';
import { Tabs, Button } from 'ui';
import { Form, message } from 'antd';
import useQueryApiClient from 'utils/useQueryApiClient';
import { useForm } from 'antd/lib/form/Form';
import { useAuth } from '../../../hooks/useAuth';
import QualityMarks from 'admin/components/EditFarm/QualityMark/QualityMark';
import { StyledQualityMarkPage } from './style';

const QualityMarksSync = () => {
  const intl = useIntl();
  const [form] = useForm();
  const { user } = useAuth();
  const farmId = user?.farmId;

  const { appendData: submitData } = useQueryApiClient({
    request: {
      url: 'api/v2/qmark/farms/' + farmId + '/qualityProducts',
      method: 'POST',
    },
    onSuccess: () =>
      message.success(
        intl.formatMessage({ id: 'quality_marks_mapping.save_success' })
      ),
    onError: () => {
      message.error(
        intl.formatMessage({ id: 'quality_marks_mapping.save_failed' })
      );
    },
  });

  const items = [
    {
      key: 'quality_marks',
      label: intl.formatMessage({ id: 'quality_marks_mapping.needs_sync' }),
      children: <QualityMarks stableFarmId={farmId} />,
    },
  ];

  const handleSubmit = async () => {
    try {
      await form.validateFields();
      const qualityMarks = form.getFieldValue('qualityMarks');
      submitData({ qualityMarks }, { farmId: farmId });
    } catch (e) {
      console.error(e);
    }
  };

  const Footer = () => {
    return (
      <div className={'footer'}>
        <Button
          label={intl.formatMessage({ id: 'general.cancel' })}
          ability={'edit_quality_mark'}
        />
        <Button
          label={intl.formatMessage({ id: 'general.save' })}
          onClick={handleSubmit}
          type={'primary'}
          ability={'edit_quality_mark'}
        />
      </div>
    );
  };

  return (
    <StyledQualityMarkPage>
      <DefaultLayout.PageLayout
        breadcrumbs={[
          {
            title: intl.formatMessage({ id: 'navigation.beginning' }),
          },
          {
            title: intl.formatMessage({ id: 'navigation.quality_marks' }),
          },
        ]}
      >
        <DefaultLayout.PageContent>
          <Form form={form} layout={'vertical'}>
            <div>
              {intl.formatMessage({
                id: 'quality_marks_mapping.info-message',
              })}
            </div>
            <Tabs items={items} />
          </Form>
        </DefaultLayout.PageContent>
      </DefaultLayout.PageLayout>
      <DefaultLayout.PageFooter>
        <Footer />
      </DefaultLayout.PageFooter>
    </StyledQualityMarkPage>
  );
};

export default QualityMarksSync;
